export default __webpack_public_path__ + "static/media/email.e588aba7.svg";